<template>
    <div class="report-widget-goal"
         v-if="planGoal && canEdit">

        <b-row class="divider"></b-row>

        <b-row>
            <b-col cols="6" class="text-right pt-2 pr-0">
                {{ planGoalPrefix }}
            </b-col>
            <b-col cols="4">
                <b-form-input v-model="goalValue">
                </b-form-input>
            </b-col>
            <b-col class="pt-2 pl-0">
                {{ planGoalSuffix }}
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue'

    /**
     * Displays a form for the Practitioner to enter a goal for a specific score, such as BMI.
     * Editing the goal value triggers autosave of the SurveyNote (see SurveyNoteEdit.js).
     */
    export default Vue.extend({
        name: 'ReportWidgetGoal',
        props: {
            scoreName: String,
        },
        computed: {
            goalValue: {
                get () {
                    return this.$store.state.draftSurveyNote.plan_goals[this.scoreName].value
                },
                set (val) {
                    this.$store.state.draftSurveyNote.plan_goals[this.scoreName].value = val
                }
            },
            canEdit () {
                return this.$user.practitionerId() != null && !this.$user.isMaskingPractitioner()
            },
            planGoal () {
                if (this.$store.state.draftSurveyNote.plan_goals) {
                    return this.$store.state.draftSurveyNote.plan_goals[this.scoreName]
                } else {
                    return {}
                }
            },
            planGoalPrefix () {
                if (this.planGoal.template) {
                    return this.planGoal.template.substring(0, this.planGoal.template.indexOf('__'))
                } else {
                    return ''
                }
            },
            planGoalSuffix () {
                if (this.planGoal.template) {
                    return this.planGoal.template.substring(this.planGoal.template.indexOf('__') + 2)
                } else {
                    return ''
                }
            },
        },
    })
</script>

<style lang="scss">
    .goal-text-input {
        width: 70%;
    }

    .wide-input {
        width: 80%;
    }
</style>
